import ConsoleTransport from './transports/console.js';
const DEFAULT_LOG_LEVEL = 'log';
export const createLoggerFactory = ({ transports = [new ConsoleTransport()] } = {}) => {
    return (namespace) => {
        const log = ({ level = DEFAULT_LOG_LEVEL, args }) => {
            for (const transport of transports) {
                transport.log({ level, namespace, args });
            }
        };
        return {
            __proto__: null,
            trace: (...args) => log({ level: 'trace', args }),
            debug: (...args) => log({ level: 'debug', args }),
            log: (...args) => log({ args }),
            info: (...args) => log({ level: 'info', args }),
            warn: (...args) => log({ level: 'warn', args }),
            error: (...args) => log({ level: 'error', args }),
        };
    };
};
export default createLoggerFactory();
